import { sendPost, sendPut } from "../base";
import { sendGet } from "../base"
import { getAPIData } from "../helpers"
import { ICancelSubscription, ISubscriptionShopify, ISubscriptionStripe } from "./types";

export const getPlans = getAPIData(sendGet("billing/subscriptions/plans/"));

export const shopifySubscription = (params: ISubscriptionShopify) => getAPIData(sendPost("billing/subscriptions/shopify/subscribe/", params))

export const stripeSubscription = (params: ISubscriptionStripe) => getAPIData(sendPost("billing/subscriptions/stripe/subscribe/", params))

export const updateCard = (params: ISubscriptionStripe) => getAPIData(sendPut("billing/subscriptions/stripe/update/", params));

export const cancelSubscription = (params: ICancelSubscription) => getAPIData(sendPost("billing/subscriptions/cancel/", params));
